import React, { useState } from 'react';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import { MainContent } from './MainContent';
import sidebarApiReference from '../../data/sidebarApiReference.json';

interface DocsLayoutProps {
  children: React.ReactNode;
  sidebarData?: any;
  title?: string;
  onSidebarToggle?: (isOpen: boolean) => void;
  isSidebarOpen?: boolean;
}

export const DocsLayout: React.FC<DocsLayoutProps> = ({ 
  children, 
  sidebarData = sidebarApiReference,
  title,
  onSidebarToggle: externalOnSidebarToggle,
  isSidebarOpen: externalIsSidebarOpen
}) => {
  const [internalSidebarOpen, setInternalSidebarOpen] = useState(true);
  
  const isSidebarOpen = externalIsSidebarOpen !== undefined ? externalIsSidebarOpen : internalSidebarOpen;
  
  const handleSidebarToggle = () => {
    const newState = !isSidebarOpen;
    setInternalSidebarOpen(newState);
    if (externalOnSidebarToggle) {
      externalOnSidebarToggle(newState);
    }
  };

  return (
    <div className="min-h-screen bg-[var(--bg-primary)]">
      <Header />
      <div className="flex h-[calc(100vh-64px)] relative">
        <Sidebar 
          sections={sidebarData.sections} 
          isOpen={isSidebarOpen}
          onToggle={handleSidebarToggle}
        />
        <main className="flex-1 overflow-y-auto bg-[var(--bg-primary)]">
          <MainContent title={title} isSidebarOpen={isSidebarOpen} onSidebarToggle={handleSidebarToggle}>
            {children}
          </MainContent>
        </main>
      </div>
    </div>
  );
};
